// extracted by mini-css-extract-plugin
module.exports = {"indicatorsTextField":"indicators-tab_indicatorsTextField__2S3qn","gray":"indicators-tab_gray__2Gez2"};